import React, { useState } from "react";
import Title from "./Title";
import Content from "./Content";
import { PageContentWrapper } from "../../shared/styled/PageContentStyle";
import { useNavigate } from "react-router-dom";
import { Material } from "../../data/entities";

const MaterialOrder = () => {
    const [selectedMaterials, setSelectedMaterials] = useState<Material[]>([]);
    const navigate = useNavigate();

    const handleSelectionChange = (rows: Material[]) => {
        setSelectedMaterials(rows);
    };

    const handleCreateMaterialOrder = () => {
        navigate("/material-orders/create?returnTab=material%20orders", {
            state: { selectedMaterials },
        });
    };

    return (
        <PageContentWrapper>
            <Title onCreateMaterialOrder={handleCreateMaterialOrder} />
            <Content onSelectionChange={handleSelectionChange} />
        </PageContentWrapper>
    );
};

export default MaterialOrder;
